import { FC } from "react";
import { Chip, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import __ from "src/utils/Translations";
import {
  IEmployeeBalanceStatus,
  PRESENTATION_TYPE,
} from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import formatBalanceCount from "src/utils/Company/Absences/formatBalanceCount";

interface IBalanceStatusProps {
  label: string;
  status: IEmployeeBalanceStatus;
  presentationType: PRESENTATION_TYPE;
  helpText?: string;
}

const BalanceStatusChip: FC<IBalanceStatusProps> = ({
  label,
  status,
  presentationType,
  helpText,
}) => {
  const { days, hours } = status;
  const balanceCount = formatBalanceCount({ days, hours, presentationType });

  const iconElement = helpText ? (
    <Tooltip title={helpText} placement="top" arrow>
      <InfoIcon />
    </Tooltip>
  ) : undefined;

  return (
    <Chip
      label={
        <>
          {__(label)}
          {": "}
          <strong>{balanceCount}</strong>
        </>
      }
      {...(helpText && {
        // Need to use deleteIcon prop to display tooltip right-aligned
        deleteIcon: iconElement,
        onDelete: () => null, // Required for deleteIcon to show
      })}
      sx={{
        bgcolor: "grey.100",
      }}
    />
  );
};

export default BalanceStatusChip;
